import { render, staticRenderFns } from "./hzmailbox.vue?vue&type=template&id=99e16d40&"
import script from "./hzmailbox.vue?vue&type=script&lang=ts&"
export * from "./hzmailbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports